import { Box, Grid, Skeleton, useMediaQuery, useTheme } from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { PER_PAGE, TargetedCheckInsContext } from "contexts/TargetedCheckIns";
import { useContext, useEffect } from "react";
import { Route, Routes } from "react-router-dom";

import ThreadPreview from "./MainEmailThread/ThreadPreview";
import MobileThreadPreview from "./MainEmailThread/ThreadPreview/mobile";
import CheckinsSidebar from "./Sidebar";
import styles from "./styles";

interface Props {
  isSmallScreen: boolean;
}

const Checkins = ({ isSmallScreen }: Props) => {
  const { currentOrg } = useContext(OrganizationUserContext);
  const { fetchTargetedActionItems, fetchCount, page, total, fetchLoading } =
    useContext(TargetedCheckInsContext);

  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    if (currentOrg?.id) {
      fetchTargetedActionItems(page);
      fetchCount();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrg?.id]);

  return (
    <Grid
      container
      sx={isSmallScreen ? styles.mobileRoot : styles.root(isMediumScreen)}
    >
      <Grid
        item
        xs={12}
        md={3.5}
        sx={isSmallScreen ? {} : styles.sidebarContainer}
      >
        {fetchLoading ? (
          <Box sx={{ px: 3 }}>
            <Skeleton height="50px" width="50%" />
            <Skeleton
              animation="wave"
              width="100%"
              height="250px"
              sx={{ mt: -4 }}
            />
            <Skeleton
              animation="wave"
              width="100%"
              height="250px"
              sx={{ mt: -10 }}
            />
            <Skeleton
              animation="wave"
              width="100%"
              height="250px"
              sx={{ mt: -10 }}
            />
            <Skeleton
              animation="wave"
              width="100%"
              height="250px"
              sx={{ mt: -10 }}
            />
          </Box>
        ) : (
          <CheckinsSidebar
            totalPages={Math.ceil(total / PER_PAGE)}
            isSmallScreen={isSmallScreen}
          />
        )}
      </Grid>

      <Routes>
        <Route
          path=":actionItemId/contact/:outreachContactId/email/:threadId"
          element={
            isSmallScreen ? (
              <MobileThreadPreview />
            ) : (
              <Grid item xs sx={styles.mainThreadContainer}>
                <ThreadPreview />
              </Grid>
            )
          }
        />
      </Routes>
    </Grid>
  );
};

export default Checkins;
